// 联系前广告闸门 mixin（global，后端 web.pages.matches.enabled 下发控制，与 client 端同一把开关）
// 策略：每天前 3 次短等（3 秒）、之后长等（15 秒），本地 localStorage 按自然日重置；仅作广告频率控制
// 使用方：MatchedSession.vue、ChannelDetail.vue —— 组件实现 gateContinue() 钩子（闸门放行后打开联系弹窗）
export default {
  data() {
    return {
      // 联系前广告闸门（global）
      showContactAdGate: false,
      contactGateSeconds: 0
    }
  },
  methods: {
    // 闸门开关：global（region 非 cn）+ config.json 下发 matches.enabled
    contactAdGateEnabled() {
      var ad = this.$config && this.$config.ad
      var pages = ad && ad.web && ad.web.pages
      var cfg = pages && pages.matches
      return this.$config && this.$config.region !== 'cn' && cfg && cfg.enabled == true
    },
    // 尝试触发闸门：闸门开启则弹出并返回 true；未开启返回 false（调用方直接放行）
    tryContactGate() {
      if (!this.contactAdGateEnabled()) return false
      var count = this.getContactAdCount()
      this.contactGateSeconds = count < 3 ? 3 : 15
      this.showContactAdGate = true
      return true
    },
    // 今日已通过闸门的联系次数（localStorage 按自然日重置）
    getContactAdCount() {
      try {
        if (localStorage.getItem('contact_ad_date') !== this.contactTodayStr()) return 0
        return parseInt(localStorage.getItem('contact_ad_count') || '0', 10) || 0
      } catch (e) {
        return 0
      }
    },
    bumpContactAdCount() {
      try {
        localStorage.setItem('contact_ad_date', this.contactTodayStr())
        localStorage.setItem('contact_ad_count', String(this.getContactAdCount() + 1))
      } catch (e) { }
    },
    contactTodayStr() {
      var now = new Date()
      var m = now.getMonth() + 1
      var d = now.getDate()
      return now.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
    },
    onContactGateContinue() {
      this.showContactAdGate = false
      this.bumpContactAdCount()
      this.gateContinue()
    },
    // 闸门放行后的动作，由使用方组件实现（打开私聊/联系弹窗）
    gateContinue() {
      throw new Error('[contactAdGate] gateContinue() must be implemented by the component using this mixin')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/contactAdGate.js